import { useDispatch, useSelector } from 'react-redux'
import { handleOnKeyDown } from 'src/utils/Form'
import { actions } from '../../DivergenceDemandsState'
import { useForm } from 'react-hook-form'
import { useHistory } from 'react-router-dom'
import { selectActiveDivergence } from 'src/features/divergence-demands/DivergenceDemandsSelector'
import { toast } from 'react-toastify'
import { useState } from 'react'
import ConfirmOrRejectModal from 'src/components/ConfirmationModal'
import * as S from './BadgeInput.styles'

interface FormData {
  badge: string;
}

const BadgeInput = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const activeDivergence = useSelector(selectActiveDivergence)
  const [showConfirmModal, setShowConfirmModal] = useState(false)
  const [pendingBadge, setPendingBadge] = useState('')
  const [userInUse, setUserInUse] = useState('')

  const {
    register,
    trigger,
    getValues,
    setError,
    formState: { errors },
  } = useForm<FormData>()

  const onSuccessfulValidation = () => {
    if (activeDivergence?.location) {
      dispatch(actions.setProperty({ property: 'divergenceActiveAddress', value: activeDivergence.location }))
      history.push('/restocking/divergence/product')
    }
  }

  const onBadgeSubmit = async () => {
    const validationSuccess = await trigger('badge')

    if (validationSuccess) {
      const badge = getValues('badge')

      dispatch(actions.validateManagerBadge({
        badge,
        divergenceId: String(activeDivergence?.id || ''),
        setError: (error: string) => {
          setError('badge', { message: error })
          toast.error('Crachá sem permissão de supervisor!')
        },
        onSuccess: onSuccessfulValidation,
        onUserInUse: (userName: string) => {
          setPendingBadge(badge)
          setUserInUse(userName)
          setShowConfirmModal(true)
        },
      }))
    }
  }

  const handleConfirmTakeover = () => {
    dispatch(actions.validateManagerBadge({
      badge: pendingBadge,
      divergenceId: String(activeDivergence?.id || ''),
      setUser: true,
      setError: (error: string) => {
        setError('badge', { message: error })
        toast.error('Erro ao assumir demanda!')
      },
      onSuccess: onSuccessfulValidation,
    }))
    setShowConfirmModal(false)
    setPendingBadge('')
    setUserInUse('')
  }

  const handleRejectTakeover = () => {
    setShowConfirmModal(false)
    setPendingBadge('')
    setUserInUse('')
  }

  return (
    <>
      <S.Container>
        <S.CustomFieldMui
          onKeyDown={(e) => handleOnKeyDown(e, '', onBadgeSubmit)}
          inputProps={{ ...register('badge', { required: true }) }}
          error={!!errors.badge}
          helperText={errors.badge?.message}
          label='replacementForm.badgelabel'
          name='badge'
          testId='input-badge-restocking-test-id'
          type='password'
          size='medium'
          fullWidth
          autoComplete='off'
          autoFocus
        />
      </S.Container>

      <ConfirmOrRejectModal
        isShow={showConfirmModal}
        title='Demanda de Divergência em execução'
        bodyText={`O usuário ${userInUse} está executando esta demanda de divergência. Deseja assumir?`}
        yesButtonAction={handleConfirmTakeover}
        noButtonAction={handleRejectTakeover}
        errorText=''
      />
    </>
  )
}

export default BadgeInput
